import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { concat } from 'lodash';
import { FetchReturn, IAssemblySearch } from 'src/interfaces';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export const useGetAssemblySearch = (
  filters: string[] = [],
  enabled: boolean = true,
) =>
  useQuery({
    queryKey: queryKeys.scheduleAssembliesSearch.all(filters),
    queryFn: () => fetchAssemblyuseGetAssemblySearch(filters),
    enabled: enabled,
    staleTime: Infinity,
  });

export const useGetAssemblySearchWithPagination = (
  filters: string[] = [],
  enabled: boolean = true,
) =>
  useInfiniteQuery({
    queryKey: queryKeys.scheduleAssembliesSearch.pagination(filters),
    queryFn: ({ pageParam = 1 }) =>
      fetchAssemblyuseGetAssemblySearch(
        concat(filters, 'sort=name', [`page=${pageParam}`], 'count=true'),
        true,
      ),
    enabled: enabled,
    staleTime: Infinity,
    getNextPageParam: (lastPage, allPages) => {
      const currentPage = lastPage ? allPages.length : 1;
      const totalPages = lastPage ? lastPage.totalPages : 1;

      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
  });

const fetchAssemblyuseGetAssemblySearch = async <T extends boolean = false>(
  filters: string[] = [],
  isPagination?: T,
): Promise<FetchReturn<T, IAssemblySearch[]>> => {
  const query = generateQuery([], filters);

  const url = `/scheduleAssemblySearch${query}`;

  const response = await requestCCApi({ url });

  if (!isPagination) {
    return response.data as FetchReturn<T, IAssemblySearch[]>;
  } else {
    return {
      data: response.data,
      totalPages: response.totalPages ?? 0,
      totalCount: response.totalCount ?? 0,
    } as FetchReturn<T, IAssemblySearch[]>;
  }
};
